<template>
  <generic-modal :title="$t('product')" ref="generic_modal">
    <!-- <div class="title is-5 is-pulled-right">
      {{ $t("price") }} {{ format_currency(meta.price) }}
    </div> -->
    <div
      class="title is-4 is-pulled-right has-text-primary"
      v-html="meta.price_html"
    ></div>
    <div class="title is-5">{{ $t("name") }} {{ meta.name }}</div>
    <div class="subtitle is-5 mb-5">
      {{ $t("status") }}:
      <span class="has-text-warning" v-if="meta.status">{{
        $t(meta.status)
      }}</span>
    </div>

    <div class="title is-6">{{ $t("sku") }}: {{ meta.sku }}</div>
    <div class="title is-6">{{ $t("type") }}: {{ meta.type }}</div>
    <div class="title is-6" v-if="meta.permalink">
      {{ $t("link") }}:
      <a :href="meta.permalink" target="_blank">{{ meta.permalink }}</a>
    </div>

    <div class="title is-6 mb-2" v-if="meta.description">
      {{ $t("description") }}
    </div>
    <div v-html="meta.description"></div>

    <!-- <div class="title is-6 mt-5" v-if="meta.images && meta.images.length">
      {{ $t("images") }}
    </div> -->
    <div class="grid mb-4">
      <div class="cell" v-for="image in meta.images">
        <v-lazy-image :src="image.src" />
      </div>
    </div>

    <div
      class="title is-5 mb-2"
      v-if="meta.attributes && meta.attributes.length"
    >
      {{ $t("attributes") }}
    </div>
    <div class="grid">
      <div class="cell" v-for="attribute in meta.attributes">
        <div class="title is-6">{{ attribute.name }}</div>
        <div class="subtitle is-6">{{ attribute.options.join(", ") }}</div>
      </div>
    </div>

    <div v-if="variations && variations.length">
      <div class="title is-5 mt-5">{{ $t("variations") }}</div>
      <div class="grid">
        <div class="cell" v-for="variation in variations">
          <!-- <pre>{{ variation }}</pre> -->
          <div class="title is-5 is-pulled-right has-text-primary">
            {{ format_currency(variation.price) }}
          </div>
          <div class="title is-6">{{ variation.name }}</div>
          <div
            class="title is-6 mb-2"
            v-if="variation.attributes && variation.attributes.length"
          >
            {{ $t("attributes") }}
          </div>
          <div class="grid">
            <div class="cell" v-for="attribute in variation.attributes">
              <div class="title is-6">{{ attribute.name }}</div>
              <div class="subtitle is-6">
                {{ attribute.option }}
              </div>
            </div>
          </div>
          <!-- <div class="title is-6">{{ variation.name }}</div>
          <div class="subtitle is-6">{{ variation.price_html }}</div> -->
        </div>
      </div>
    </div>

    <!-- <pre>{{ variations }}</pre> -->
    <!-- <pre>{{ meta }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <!-- <button class="button is-rounded" @click="update_order">
        <span class="icon">
          <i class="fa fa-server"></i>
        </span>
        <span>{{ $t("update") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "WooCommerceProductModal",
  components: { GenericModal, VLazyImage },
  data() {
    return {
      meta: { settings: {} },
      variations: [],
      error: "",
    };
  },
  props: {},
  computed: {},
  methods: {
    change_active_tab,
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/woocommerce/product", { uuid: uuid })
        .then((product) => {
          v.meta = product.json_data;
          v.variations = product.variations_json_data;
          v.meta.uuid = uuid;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });

      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
    },
    update_order() {
      let v = this;
      v.$root.loader(true);
      get("/woocommerce/order/from-server", { uuid: v.meta.uuid })
        .then((order) => {
          v.$emit("order_updated");
          v.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
